// extracted by extract-css-chunks-webpack-plugin
module.exports = {"loaderContainer":"lgpegy+-TPFx","loader":"P62L2-jxYJIf","span-spin":"O-yaxpSj9qVV"};